import { type UseQueryResult, useQuery } from 'react-query';
import {
  EsppEnrollmentService,
  PagedResultDto_EsppEnrollmentRowDto,
} from '@wealthlane/api-services/wealthlane-award-service';
import { TableParamsType } from '../../types/common';

const useGetPurchaseEnrollmentList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  offeringPeriodId?: string,
  purchasePeriodId?: string
): UseQueryResult<PagedResultDto_EsppEnrollmentRowDto | undefined, unknown> => {
  const { filter: searchKeyWord, sorting, skipCount, maxResultCount } = tableInfo;

  return useQuery(
    [
      'getPurchaseEnrollmentList',
      offeringPeriodId,
      purchasePeriodId,
      searchKeyWord,
      sorting,
      skipCount,
      maxResultCount,
    ],
    async () => {
      if (!offeringPeriodId || !purchasePeriodId) return undefined;
      return await handleRequest(
        EsppEnrollmentService.getApiAwardApiAwardOfferingPeriodPurchasePeriodEnrollment(
          offeringPeriodId,
          purchasePeriodId,
          ['Enrolled'],
          undefined,
          undefined,
          searchKeyWord,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    },
    {
      enabled: !!offeringPeriodId && !!purchasePeriodId,
      select: (data) => (data != null ? data : undefined),
    }
  );
};

export default useGetPurchaseEnrollmentList;
